import { render, staticRenderFns } from "./xreportemodal.vue?vue&type=template&id=32c3e826"
import script from "./xreportemodal.vue?vue&type=script&lang=js"
export * from "./xreportemodal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports